// removed by extract-text-webpack-plugin
module.exports = {"headerBox":"_24vBD8sEDCocFm6UgY69Lx","header":"_3yzKE9iekruZUpI52S7OW9","right":"_2Ce1gOszZKfdbBN9S9TZ5D","seeMore":"pECNe-KJPez4xQFHwC6ms","arrowRight":"_18QCTuBYUeMPBxpOE15wP6","left":"_3QT6Nt2KdyBxBGlDaYbxlu","title":"_1LqQD-68Bo-pg0tANOikoU","slogan":"_2ggwEdHbzcp1RUD2rNPnvy","collection":"_2KXZEyTkYcF8eT5Sfa2Ezd","collectionList":"_3Yqct_p7Ttc_ERyI4d1mYA","onlyOne":"_2aUVA76Rkgtn5ot1OyBknA","item":"_1-SpSRiesrhYyznOnEabdA","lastItem":"_3jhZpLHZuGjxofIQEhNK3y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/Collection.scss
// module id = 1140
// module chunks = 0